import type { JSX } from 'react';
import { FormActions } from '@/components/form';
import { PillButton } from '@/components/entity/PillButton';
import type { PropertyCreateFieldChangeFactory, PropertyCreateFormState } from './types';

interface PropertyCreateActionsProps {
  formState: PropertyCreateFormState;
  disabled: boolean;
  onFieldChange: PropertyCreateFieldChangeFactory;
  onCancel: () => void;
}

export function PropertyCreateActions({
  formState,
  disabled,
  onFieldChange,
  onCancel,
}: PropertyCreateActionsProps): JSX.Element {
  return (
    <FormActions justify="between">
      <label className="flex items-center gap-2 text-sm font-semibold text-text-primary/80">
        <input
          type="checkbox"
          checked={formState.viewDetailsOnCreate}
          onChange={onFieldChange('viewDetailsOnCreate')}
          disabled={disabled}
          className="h-4 w-4 rounded border-surface-subtle text-brand-primary focus:ring-brand-primary"
        />
        View Property Details on Creation
      </label>
      <div className="flex items-center gap-3">
        <button
          type="button"
          className="rounded-full px-4 py-2 text-sm font-semibold text-text-primary/70 transition hover:bg-surface-subtle disabled:opacity-60"
          onClick={onCancel}
          disabled={disabled}
        >
          Cancel
        </button>
        <PillButton type="submit" disabled={disabled}>
          {disabled ? 'Creating…' : 'Create property'}
        </PillButton>
      </div>
    </FormActions>
  );
}
